import Button from "@mui/material/Button";
import styles from "../../styles/ProductCardBundle.module.css";
import { StyledLabelRegular } from "../../styled";
import { addToCart_GA } from "../../utils/GoogleAnalytics";
import { useUpdateCart } from "../../hooks/useManageCart";
import { useNavigate } from "react-router-dom";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { useCallback, useEffect, useState } from "react";

const ProductCard = ({ product, cart }) => {
  const navigate = useNavigate();
  const [msg, setMsg] = useState("");
  const { shortName, price, thumbnail, sku } = product;
  const { mutate, isError, isSuccess, error } = useUpdateCart();

  const handleAddToCart = () => {
    addToCart_GA({ id: sku, quantity: 1 });
    mutate({
      items: [{ sku: sku, quantity: 1 }],
      itemsRemoved: [],
      rewardPoints: 0,
      couponCode: "",
      discount: 0,
      isPercent: false,
    });
  };

  const resetError = () => setMsg("");

  const handleAlert = useCallback(() => {
    if (isSuccess) setMsg("Your item is successfully added to cart");
    if (isError) setMsg(error?.message);
  }, [isSuccess, isError, error]);

  useEffect(() => handleAlert(), [handleAlert]);

  const handleProductClick = () => navigate(`/products/${sku}`);
  const isInCart = cart?.items?.some((item) => item.sku === sku);

  return (
    <section className={styles.productWrapper}>
      <section className={styles.productThumbnail}>
        <section onClick={handleProductClick} className={styles.product}>
          <section className={styles.productMedia}>
            <img
              className={styles.productMedia}
              src={thumbnail}
              alt={shortName}
              loading="lazy"
            />
          </section>
          <section className={styles.productInfo}>
            <StyledLabelRegular className={styles.title}>
              {shortName}
            </StyledLabelRegular>
            <StyledLabelRegular className={styles.price}>
              ${price.toFixed(2)}
            </StyledLabelRegular>
          </section>
        </section>
        <section className={styles.productActions}>
          <Button
            sx={{ height: "40px" }}
            onClick={handleAddToCart}
            variant="btn-primary-outlined"
            fullWidth
            disabled={isInCart}
          >
            {isInCart ? "In Your Cart" : "Add to Cart"}
          </Button>
        </section>
        <Snackbar
          onClose={resetError}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          autoHideDuration={6000}
          open={(isError || isSuccess) && msg !== ""}
        >
          <Alert severity={isError ? "error" : isSuccess ? "success" : "info"}>
            {msg}
          </Alert>
        </Snackbar>
      </section>
    </section>
  );
};

export default ProductCard;
